import { useQuery } from '@apollo/client';

import { setAssetTypeLabels } from 'utils/Asset/assetTypeLabels';

import assetTypeLabelsQuery from './assetTypeLabels.graphql';

/**
 * Loads the asset type labels into the module-level map `assetTypeText` reads.
 * Callers: SentinelRoute (every Sentinel page) and useTeamAssetFilter, because
 * the Management routes sit outside SentinelRoute.
 *
 * The map is set during render, not in an effect, so a memo that lists
 * `labels` in its deps reads the new labels in the same render.
 */
export default function useAssetTypeLabels({
  skip = false,
}: { skip?: boolean } = {}) {
  const { data, loading } = useQuery<AssetTypeLabelsQuery>(
    assetTypeLabelsQuery,
    { fetchPolicy: 'cache-first', skip },
  );

  const labels = data?.assetTypeLabels;
  if (labels) setAssetTypeLabels(labels);

  return { labels, loading };
}
